import { Component } from '@angular/core';
import { setIsLoading } from '../../shared/components/app-loading-overlay/app-loading-overlay.component';
@Component({
  selector: 'app-test-loading',
  template: `
    <div class="container mt-5">
      <div class="row justify-content-center">
        <div class="col-md-6 text-center">
          <h2>Loading Overlay Test Page</h2>
          <p class="mb-4">Click the button below to toggle the loading overlay</p>
          <button class="btn btn-primary" (click)="toggleLoading()">
            {{ isLoading ? 'Hide Loading' : 'Show Loading' }}
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .container {
      min-height: 100vh;
    }
  `]
})
export class TestLoadingComponent {
  isLoading = false;
  toggleLoading() {
    this.isLoading = !this.isLoading;
    setIsLoading(this.isLoading);
  }
}
